export default __webpack_public_path__ + "static/media/kanit-light.a5db0b51.ttf";